import { Controller, useForm } from "react-hook-form";
import { makeUtilClasses } from "../../../../theme";
import { DefaultFormProps, DefaultFormRefs } from "../../utils";
import React from "react";
import { CircularLoading } from "../../../utils";
import { Button, Grid } from "@material-ui/core";
import { useStyles } from "./form-modo-styles";
import { SelectSaurus } from "../../../controles/selects/select-saurus/select-saurus";
import { ModoAplicacaoMock } from "../../../../../data/mocks/modo-aplicacao-mock";
import { ModuloModel } from "../../../../../model/app/forms/master/modulo-model";
import { useKdsToken, useSessaoAtual } from "../../../../../services/app";
import { isPlanoDelivery } from "../../../../../utils/plano-utils";
import { EnumModulo } from "../../../../../model/enums/enum-modulo";
import { EnumCadastroTipo } from "../../../../../model";

export const FormModulo = React.forwardRef<
  DefaultFormRefs<ModuloModel>,
  DefaultFormProps<ModuloModel>
>((props: DefaultFormProps<ModuloModel>, refs) => {
  const utilClasses = makeUtilClasses();
  const classes = useStyles();
  const { plano, } = useSessaoAtual()
  const { getPessoaUsuario } = useKdsToken()

  const {
    handleSubmit,
    control,
    setValue,
    reset,
  } = useForm<ModuloModel>({
    criteriaMode: 'all',
    mode: 'onSubmit',
  });

  const onSubmit = (form: ModuloModel) => {
    props.onSubmit(form);
  };

  React.useImperativeHandle(refs, () => ({
    submitForm: () => {
      handleSubmit(onSubmit)();
    },
    resetForm: () => {
      reset();
    },
    fillForm: (model: ModuloModel) => {
      reset();
    },
  }));

  const mockModulos = ModoAplicacaoMock.filter(x => {
    const pessoaUsuario = getPessoaUsuario()
    if (pessoaUsuario.pessoa.tpCadastro === EnumCadastroTipo.TRANSPORTADORA) {
      return x.Key === EnumModulo.Motoboy
    }
    if (!isPlanoDelivery(plano?.plano)) {
      return x.Key !== EnumModulo.Motoboy && x.Key !== EnumModulo.EntregaDelivery;
    }
    return true;
  });

  return (
    <>
      <div className={utilClasses.formContainer}>
        {props.loading && props.showLoading ? (
          <CircularLoading tipo="FULLSIZED" />
        ) : null}
        <form
          onSubmit={handleSubmit(onSubmit)}
          className={`${classes.formContainer} ${props.loading ? utilClasses.controlLoading : ''
            }`}
        >
          <Grid container style={{
            maxWidth: '100%',
          }}>
            <Grid item xs={12} style={{
              display: 'flex',
              justifyContent: 'center'
            }}>
              <Controller
                name="modulo"
                control={control}
                render={({ field }) => (
                  <SelectSaurus
                    conteudo={mockModulos}
                    fullWidth
                    variant="outlined"
                    label={'Módulo da Aplicação'}
                    {...field}
                    onChange={(event) => {
                      if (event) {
                        const item = mockModulos.filter(
                          (item) => item.Key === event.target.value,
                        )[0];
                        if (item) {
                          setValue('modulo', item.Key);
                        }
                      }
                    }}
                  />
                )}
              />
            </Grid>
          </Grid>
          <Button style={{ display: 'none' }} type="submit"></Button>
        </form>
      </div>
    </>
  );
});
